export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow-x: hidden;
          overflow-y: hidden;
          user-select: none;
          width: 100%;
        }
        click-effect {
          position: fixed;
          top: 0;
          left: 0;
          pointer-events: none;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @font-face {
          font-family: 'Samuel3';
          src: url("assets/firekirin/fonts/Samuel3.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `,
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#274564',
    },
    secondary: {
      main: '#818181',
    },
    toolbar: {
      main: '#ffffff',
    }
  },
}
